export var ChannelGameCategory;
(function (ChannelGameCategory) {
    ChannelGameCategory["SLOT"] = "slot";
    ChannelGameCategory["CARD"] = "card";
    ChannelGameCategory["ARCADE"] = "arcade";
    ChannelGameCategory["FISH"] = "fish";
    ChannelGameCategory["OTHER"] = "other";
})(ChannelGameCategory || (ChannelGameCategory = {}));
//# sourceMappingURL=ChannelCategoryType.js.map